import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { HelmetProvider } from "react-helmet-async";
import { Toaster } from "@/components/ui/sonner";
import ScrollToTop from "@/components/ScrollToTop";
import Home from "@/pages/Home";
import Workflow from "@/pages/Workflow";
import HowItWorks from "@/pages/HowItWorks";
import SeoLanding from "@/pages/SeoLanding";
import AbonelikIptaliRehberi from "@/pages/AbonelikIptaliRehberi";
import Hakkimizda from "@/pages/Hakkimizda";
import Iletisim from "@/pages/Iletisim";
import GizlilikPolitikasi from "@/pages/GizlilikPolitikasi";
import KvkkAydinlatmaMetni from "@/pages/KvkkAydinlatmaMetni";
import KullanimSartlari from "@/pages/KullanimSartlari";
import CerezPolitikasi from "@/pages/CerezPolitikasi";
import HaklariniziOgrenin from "@/pages/HaklariniziOgrenin";
import NotFound from "@/pages/NotFound";
import { SEO_PAGES } from "@/data/seoPages";

function App() {
  return (
    <div className="App">
      <HelmetProvider>
        <BrowserRouter>
          <ScrollToTop />
          <Routes>
            <Route path="/" element={<Home />} />
            <Route path="/dosya-baslat" element={<Workflow />} />
            <Route path="/nasil-calisir" element={<HowItWorks />} />
            <Route path="/abonelik-iptali-rehberi" element={<AbonelikIptaliRehberi />} />
            <Route path="/hakkimizda" element={<Hakkimizda />} />
            <Route path="/iletisim" element={<Iletisim />} />
            <Route path="/gizlilik-politikasi" element={<GizlilikPolitikasi />} />
            <Route path="/kvkk-aydinlatma-metni" element={<KvkkAydinlatmaMetni />} />
            <Route path="/kullanim-sartlari" element={<KullanimSartlari />} />
            <Route path="/cerez-politikasi" element={<CerezPolitikasi />} />
            <Route path="/haklarinizi-ogrenin" element={<HaklariniziOgrenin />} />
            {SEO_PAGES.map((p) => (
              <Route
                key={p.slug}
                path={`/${p.slug}`}
                element={<SeoLanding config={p} />}
              />
            ))}
            <Route path="*" element={<NotFound />} />
          </Routes>
        </BrowserRouter>
      </HelmetProvider>
      <Toaster position="top-center" richColors />
    </div>
  );
}

export default App;
